(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {


  /* =========================================================
     SECTION
  ========================================================= */

  const sections =
    document.querySelectorAll(
      '[id^="CategorySlider-"]'
    );


  sections.forEach(function(section) {


    if (
      section.dataset.initialized === 'true'
    ) {
      return;
    }


    section.dataset.initialized =
      'true';



    /* =======================================================
       CATEGORY TABS
    ======================================================= */

    const tabButtons =
      section.querySelectorAll(
        '.category-tab-button'
      );


    const tabContents =
      section.querySelectorAll(
        '.category-tab-content'
      );


    tabButtons.forEach(function(button) {


      button.addEventListener(
        'click',
        function() {


          const handle =
            button.dataset.tab;



          tabButtons.forEach(function(btn) {

            btn.classList.remove(
              'active'
            );

          });



          tabContents.forEach(function(content) {

            content.classList.remove(
              'active'
            );

          });



          button.classList.add(
            'active'
          );


          const selectedTab =
            section.querySelector(
              '#tab-' + handle
            );


          if (selectedTab) {

            selectedTab.classList.add(
              'active'
            );

          }


        }
      );


    });



    /* =======================================================
       ARROW CONTROLS
    ======================================================= */

    section
      .querySelectorAll(
        '.category-prev'
      )
      .forEach(function(button) {


        button.addEventListener(
          'click',
          function() {


            const handle =
              button.dataset.handle;


            const slider =
              section.querySelector(
                '#slider-' + handle
              );


            if (slider) {

              slider.scrollBy({
                left: -250,
                behavior: 'smooth'
              });

            }


          }
        );


      });



    section
      .querySelectorAll(
        '.category-next'
      )
      .forEach(function(button) {


        button.addEventListener(
          'click',
          function() {


            const handle =
              button.dataset.handle;


            const slider =
              section.querySelector(
                '#slider-' + handle
              );


            if (slider) {

              slider.scrollBy({
                left: 250,
                behavior: 'smooth'
              });

            }


          }
        );


      });



    /* =======================================================
       AUTO SCROLL
    ======================================================= */

    const sliders =
      section.querySelectorAll(
        '.category-product-slider'
      );


    sliders.forEach(function(slider) {


      const originalItems =
        Array.from(
          slider.children
        );


      if (!originalItems.length) {
        return;
      }



      /* =====================================================
         DUPLICATE ITEMS FOR INFINITE LOOP
      ===================================================== */

      if (
        slider.dataset.loopInitialized !== 'true'
      ) {


        originalItems.forEach(
          function(item) {


            const clone =
              item.cloneNode(true);


            clone.classList.add(
              'clone-item'
            );


            clone.setAttribute(
              'aria-hidden',
              'true'
            );



            clone
              .querySelectorAll('[id]')
              .forEach(function(element) {

                element.removeAttribute(
                  'id'
                );

              });



            /*
              Clones are only for visual infinite movement.
              Buttons/forms are disabled in clones.
            */

            clone
              .querySelectorAll(
                'button, input, form'
              )
              .forEach(function(element) {

                element.setAttribute(
                  'tabindex',
                  '-1'
                );

              });



            slider.appendChild(
              clone
            );


          }
        );


        slider.dataset.loopInitialized =
          'true';

      }



      /* =====================================================
         SPEED

         LOWER NUMBER = SLOWER

         MOBILE = 0.6
         TABLET = 0.4
         DESKTOP = 0.28
      ===================================================== */

      let speed =
        0.28;


      function updateSpeed() {


        const width =
          window.innerWidth;


        if (width < 640) {

          speed = 0.6;

        }

        else if (width < 1024) {

          speed = 0.4;

        }

        else {

          speed = 0.28;

        }


      }


      updateSpeed();


      window.addEventListener(
        'resize',
        updateSpeed
      );



      /* =====================================================
         PAUSE CONTROLS
      ===================================================== */

      let paused =
        false;


      let wheelTimer =
        null;


      let userTouching =
        false;


      function pause() {

        paused = true;

      }


      function resume() {

        if (!userTouching) {

          paused = false;

        }

      }



      /* HOVER */

      slider.addEventListener(
        'mouseenter',
        pause
      );


      slider.addEventListener(
        'mouseleave',
        resume
      );



      /* TOUCH */

      slider.addEventListener(
        'touchstart',
        function() {

          userTouching =
            true;

          pause();

        },
        {
          passive: true
        }
      );


      slider.addEventListener(
        'touchend',
        function() {

          userTouching =
            false;

          setTimeout(
            resume,
            400
          );

        },
        {
          passive: true
        }
      );


      slider.addEventListener(
        'touchcancel',
        function() {

          userTouching =
            false;

          setTimeout(
            resume,
            400
          );

        },
        {
          passive: true
        }
      );



      /* MOUSE DOWN */

      slider.addEventListener(
        'mousedown',
        pause
      );


      document.addEventListener(
        'mouseup',
        resume
      );



      /* WHEEL */

      slider.addEventListener(
        'wheel',
        function() {


          pause();


          clearTimeout(
            wheelTimer
          );


          wheelTimer =
            setTimeout(
              resume,
              600
            );


        },
        {
          passive: true
        }
      );



      /* =====================================================
         AUTO-SCROLL LOOP

         Moves visually RIGHT -> LEFT.
      ===================================================== */

      function animate() {


        if (!paused) {


          slider.scrollLeft +=
            speed;



          const half =
            slider.scrollWidth / 2;



          if (
            half > 0 &&
            slider.scrollLeft >= half
          ) {


            slider.scrollLeft -=
              half;


          }


        }



        requestAnimationFrame(
          animate
        );


      }


      requestAnimationFrame(
        animate
      );


    });



    /* =======================================================
       BUY NOW

       Adds 1 item then redirects directly to Shopify checkout.
    ======================================================= */

    section.addEventListener(
      'click',
      async function(event) {


        const button =
          event.target.closest(
            '.buy-now-button'
          );


        if (
          !button ||
          button.disabled
        ) {
          return;
        }



        event.preventDefault();


        const variantId =
          button.dataset.variantId;


        if (!variantId) {
          return;
        }



        const originalText =
          button.textContent.trim();



        button.disabled =
          true;


        button.textContent =
          'Loading...';



        try {


          const response =
            await fetch(
              window.Shopify.routes.root + 'cart/add.js',
              {

                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'
                },

                body:
                  JSON.stringify({

                    items: [
                      {
                        id:
                          Number(variantId),

                        quantity:
                          1
                      }
                    ]

                  })

              }
            );



          if (!response.ok) {

            throw new Error(
              'Product could not be added.'
            );

          }



          /*
            Go directly to checkout
          */

          window.location.href =
            '/checkout';


        }


        catch(error) {


          console.error(
            'Buy Now Error:',
            error
          );


          button.disabled =
            false;


          button.textContent =
            originalText;


          alert(
            'Unable to proceed to checkout. Please try again.'
          );


        }


      }
    );


  });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
